<template>
  <div class="col-xs-12 p-0 searchBackground">
    <div class=" d-flex p-0 ">
    <div class="search-items  search-text w-10" :class="componentName==='contactDetails'?'pr-0':''">
       <span v-if="searchCount===1">{{ searchCount }} {{$t('itemText')}}</span>
        <span v-else>{{ searchCount }} {{$t('items')}}</span>
    </div>
    <div class="input-with-icon d-flex">
    <input
      class=" form-control search-box"
      type="text" v-model.trim="searchKeyword"
      :placeholder="searchPlaceholder?searchPlaceholder:$t('search')"
      @keydown.enter.prevent="emitGetList"
      @keyup="fetchAccountList"
     />
     <span @click="emitGetList()" class="search-icon cursor-pointer" :class="{ 'events-none': disableSearch }">
        <img src="/static/images/icons/search_UL.svg" />
      </span>
      </div>
     </div>
      <span v-if="showFilter" class="divider-line"></span>
    <service-providers-filter v-if="componentName=='service providers'"></service-providers-filter>
    <manage-compliance-filter v-if="componentName=='manage compliance'" :selectedColumns="selectedColumns"  @updateColumns="updateColumns" @updateFilterMode="updateFilterMode"></manage-compliance-filter>
    <launch-pad-filter v-if="componentName=='launchPadFilter'" @updateStatus="updateStatusTable" @updateDate="updateDateInTable"></launch-pad-filter>
  </div>
</template>

<script>
import $ from 'jquery';
import ServiceProvidersFilter from '../RepresentationResources/ServiceProvidersFilter.vue';
import ManageComplianceFilter from '../Registrations/ManageComplianceFilter.vue';
import LaunchPadFilter from '../SuperAdmin/LaunchpadFilter.vue';

export default {
  components: {
    ServiceProvidersFilter,
    ManageComplianceFilter,
    LaunchPadFilter,
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    disableSearch: {
      required: false,
    },
    fetchAccountsBasedOnSearch: {
      required: false,
      default: false,
    },
    complianceTracker: {
      required: false,
    },
    teamBorder: {
      required: false,
    },
    searchCount: {
      type: Number,
      required: false,
    },
    showFilter: {
      required: false,
    },
    componentName: {
      type: String,
      required: false,
    },
    selectedColumns: {
      required: false,
      type: Array,
    },
    searchPlaceholder: {
      required: false,
      type: String,
    },
  },

  data() {
    return {};
  },

  computed: {
    searchKeyword: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    openFilterModal() {
      $('#serviceProvidersFilterModal').modal();
    },
    resetSearchKeyword() {
      this.searchKeyword = '';
      this.emitGetList();
    },

    fetchAccountList() {
      if (this.fetchAccountsBasedOnSearch) {
        this.$emit('fetchAccount');
      }
    },

    emitGetList() {
      this.$emit('getList');
    },
    updateColumns(columns, mode) {
      // this.manageComplianceColumns = [...columns];
      this.$emit('updateColumns', columns, mode);
    },
    updateStatusTable(mode1, mode2) {
      this.$emit('updateStatusTable', mode1, mode2);
    },
    updateDateInTable(from, to) {
      this.$emit('updateDateInTable', from, to);
    },
    updateFilterMode(mode) {
      this.$emit('updateFilterMode', mode);
    },
  },
};
</script>

<style scoped>
.divider-line {
  border-left: 1px solid #CCCCCC;
  position: absolute;
  right: 96px;
  height: 54px;
  top: 1px;
}
.search-bar-filter {
  border-left: 1px solid #CCCCCC;
}
/* input[type=text] {
    width: 100%;
    box-sizing: border-box;
    border: none;

    font-size: 16px;
    background-color: none;
    background-image: url('/static/images/icons/search_UL.svg');
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 20px 12px 40px;
    outline: none;
    border: 1px solid #D3D3D3;
} */
.input-with-icon {
  /* causes absolute icon div to be positioned correctly */
  position: relative;

  /* width: 25rem; */
  /* height: 3.2rem; */
  box-sizing: border-box;
  margin-top: 0px;
    margin-bottom: 0px;
    width: 100%;
    border: 1px solid #D3D3D3;
}

.input-with-icon .form-control {
    height: 100%;
    width: 100%;
    padding-right: 3.65rem;
    box-sizing: border-box;
}

.input-with-icon .icon {
  position: absolute;

  /* These are set relative to the height of the input box to bound the box neatly inside. This is aesthetic to me but you may change the dimensions of course. */
  right: 0.3rem;
  top: 0.3rem;
  /* width: 2.6rem; */
  /* height: 2.6rem; */
  border-radius: 0.3rem;

  /* content in the icon div is centered, without bootstrap or font-awesome you may wish to add your own text in the span */
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  /* margin-top: 0px;
    margin-bottom: 0px;
    width: 100%;
    border: 1px solid #D3D3D3; */
}

/*
 BELOW PROPERTIES AREN'T CRITICAL FOR DESIRED BEHAVIOUR.
 THEY ARE PURELY FOR DEMONSTRATION PURPOSES
*/
/* .input-with-icon {
  margin: 0.8rem;
}

.input-with-icon .form-control {
  padding-left: 1.2rem;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
} */

.input-with-icon .icon {
  border: 1px solid black;
}
.searchBackground {
  background-color: #FFFFFF;
}
.w-10 {
    width: 12%;
}
.search-items {
    padding: 18px 33px 17px 16px;
    border-bottom: 1px solid #D3D3D3 ;
    border-top: 1px solid #D3D3D3;
    border-left: 1px solid #D3D3D3 ;
}
.form-control::placeholder {
  color: rgba(0, 0, 0, 0.5);
}
.search-reset {
  top: 7px;
  right: 50px;
  height: 22px;
  width: 22px;
}

.search-box {
  padding-left: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #4D4D4D;
  padding-right: 84px;
  padding-left: 48px;
  border: 1px solid #D3D3D3;
  border-radius: 0px;
  padding-top: 17px;
  padding-bottom: 15px;
  border: none !important
}

.form-control:focus {
  border-color: #D3D3D3;
}

.search-box:hover {
  box-shadow: none;
}

.search-icon {
  top: 14px;
  position: absolute;
  /* left: 180px; */
  padding-left: 16px;
}

.form-control {
  height: 54px !important;
  box-shadow: none;
}

.events-none {
  cursor: not-allowed;
  pointer-events: none;
}
.pl-104{
    padding-left:104px;
}
.pr-0 {
    padding-right:0!important;
}
.search-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #4D4D4D;
}
@media (min-width: 1301px) and (max-width: 1399px){
  .w-10 {
    width: 12%;
}
}
</style>
